import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { StepNavigationTemplate } from '@components/v2/StepNavigation/StepNavigationTemplate';
import { rem } from 'polished';

export const StepNavigationStyled = styled(StepNavigationTemplate)`
    .opened,
    .closed {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        @media (max-width: ${breakpoints.lg}px) {
            background: ${({ theme }) => theme.colors.white} !important;
            padding: ${rem('10px')};
        }

        .contactUsContainer {
            width: 30%;
            display: flex;
            padding-left: ${rem(46)};
            text-decoration: none;
            align-items: center;

            .contactUsActionButton {
                border: none;
                cursor: pointer;
                background: transparent;
            }
            @media (max-width: ${breakpoints.lg}px) {
                display: none;
            }
        }

        .wrapper {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 70%;

            @media (min-width: ${breakpoints.lg}px) {
                position: relative;
                background: ${({ theme }) => theme.colors.white};
                overflow: hidden;
            }

            @media (max-width: ${breakpoints.lg}px) {
                height: ${rem('30px')};
            }

            .project {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                font-weight: bold;
                margin-right: ${rem('6px')};
                display: none;

                @media (max-width: ${breakpoints.lg}px) {
                    display: flex;
                }
            }

            .blurryHolder {
                display: none;
                @media (min-width: ${breakpoints.lg}px) {
                    width: 50px;
                    height: 100%;
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    overflow: hidden;
                    cursor: pointer;

                    &.isRight {
                        right: 0;
                    }

                    &.isLeft {
                        left: 0;

                        .icon-wrapper {
                            &:after,
                            svg {
                                transform: rotate(180deg);
                            }
                        }
                    }

                    .icon-wrapper {
                        position: absolute;
                        z-index: 999;

                        svg {
                            filter: blur(-5px);

                            path {
                                fill: ${({ theme }) => theme.colors.primary};
                            }
                        }
                    }

                    .blurry {
                        filter: blur(5px);
                        background: white;
                        z-index: 9;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100px;
                        width: 50px;
                    }
                }
            }

            .container {
                display: flex;
                justify-content: center;
                align-items: center;
                transition: left 0.3s ease-in-out;
            }
        }

        .chevron-down {
            display: none;

            @media (max-width: ${breakpoints.lg}px) {
                display: flex;
            }

            svg path {
                fill: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .nav-item {
        display: flex;
        margin: ${rem('6px')} ${rem('6px')} 0 ${rem('6px')};
        cursor: pointer;
        border-bottom: ${rem('6px')} solid ${({ theme }) => theme.colors.white};
        border-top: none;
        border-left: none;
        border-right: none;
        align-items: center;
        justify-content: center;
        padding: ${rem('10px')};
        background: none;
        white-space: nowrap;
        user-select: none;

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
        }

        .icon {
            width: ${rem('22px')};
            height: ${rem('22px')};
            border: 1px solid ${({ theme }) => theme.colors.primary};
            border-radius: 100%;
            margin-right: ${rem('10px')};
            position: relative;

            svg {
                margin-top: ${rem(2)};
                margin-left: ${rem(2)};
                position: absolute;
                left: 0;

                g {
                    fill: ${({ theme }) => theme.colors.primary};
                }
            }
        }

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        }

        @media (max-width: ${breakpoints.lg}px) {
            padding: unset;
            margin: ${rem('5px')};
            border: unset;

            .icon {
                margin-right: unset;
            }

            .title {
                display: none;
            }
        }
    }

    .opened {
        @media (max-width: ${breakpoints.lg}px) {
            padding: unset;
            background: ${({ theme }) => theme.colors.white};

            .wrapper {
                position: relative;
                width: 100%;

                .project {
                    margin-left: ${rem('10px')};
                    position: absolute;
                    left: 0;
                }

                .container {
                    flex-direction: column;
                    position: absolute;
                    top: ${({ isUserLoggedInAsDealer }) => (isUserLoggedInAsDealer ? rem(36) : 0)};
                    background: ${({ theme }) => theme.colors.white};
                    width: 100%;
                    padding: ${rem('10px')};
                    border-bottom: 1px solid ${({ theme }) => theme.colors.grey28};
                    margin-top: ${rem('31px')};
                }
            }

            .chevron-down {
                transform: rotate(180deg);
                position: absolute;
                right: ${rem('10px')};
            }
        }

        .nav-item {
            width: 100%;
            justify-content: flex-start;
            position: relative;

            &:after {
                border-style: solid;
                border-width: ${rem('0.5px')} ${rem('0.5px')} 0 0;
                content: '';
                display: inline-block;
                height: ${rem('5px')};
                right: 0;
                position: absolute;
                transform: rotate(45deg);
                vertical-align: top;
                width: ${rem('5px')};
            }

            .title {
                display: flex;
                margin-left: ${rem('10px')};
            }
        }
    }
`;
